import { useEffect, useState } from 'react'

const useRejectDetails = (initialValues = {}) => {
  const [values, setValues] = useState(initialValues)
  const [lengths, setLengths] = useState({})
  const [behaviors, setBehaviors] = useState({})
  const [exclusions, setExclusions] = useState([])
  const [scopes, setScopes] = useState({})
  const [rateCodeCategory, setRateCodeCategory] = useState(null)

  const setValue = (name, value) => {
    let newValues = { ...values, [name]: value }
    if (!value) {
      delete newValues[name]
    }
    setValues(newValues)
  }

  const setLength = (name, length) => {
    setLengths({ ...lengths, [name]: length })
  }

  const setBehavior = (name, behavior) => {
    setBehaviors({ ...behaviors, [name]: behavior })
  }

  const setScope = (name, scope) => {
    setScopes({ ...scopes, [name]: scope })
  }

  useEffect(() => {
    let arr = Object.keys(values)
      .filter(key => values[key])
      .map(key => {
        let returnObj = {
          behavior: null,
          scope: null,
          requestCategory: key
        }

        if (lengths[key]) {
          returnObj.length = lengths[key]
        }

        if (behaviors[key]) {
          returnObj.behavior = behaviors[key]
        }

        if (scopes[key]) {
          returnObj.scope = scopes[key]
        }

        return returnObj
      })

    setExclusions(arr)
  }, [behaviors, lengths, scopes, values])

  return {
    values,
    rateCodeCategory,
    lengths,
    setValue,
    setLength,
    setBehavior,
    setScope,
    setRateCodeCategory,
    exclusions
  }
}

export default useRejectDetails
